module.exports = __webpack_public_path__ + "static/media/view4.8f90d45c.jpg";